import React, { useState } from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonInput,
  IonItem,
  IonList,
  IonButton,
  IonLabel,
  IonText,
  IonLoading,
  IonAlert,
} from '@ionic/react';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/userActions';

const EditItemContainer: React.FC = (props: any) => {
  const { user, userDBInfo } = props;

  const [send, setSend] = useState<string>('Send Request');
  const [showAlert1, setShowAlert1] = useState<boolean>(true);

  if (!userDBInfo) {
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>Sweep Balance</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <img
            src="assets/sweep.svg"
            alt="logo"
            className="centered"
            style={{
              width: 250,
              marginTop: '5vh',
              marginBottom: '5vh',
              display: 'block',
            }}
          />
          <IonItem>
            <IonLabel position="stacked">
              Available Balance(KES) <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              value={userDBInfo.availableBalance?.toFixed(2)}
              readonly
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">
              MPESA Number <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput value={userDBInfo.number} readonly></IonInput>
          </IonItem>

          <IonButton
            expand="block"
            disabled={!userDBInfo.availableBalance}
            onClick={() => {
              setSend('sending...');
              setTimeout(() => setSend('Sent'), 3000);
              setTimeout(() => setSend('Send Request'), 7000);
              props.onRequestSweep({
                amount: userDBInfo.availableBalance?.toFixed(2),
                accountNumber: userDBInfo.number,
                email: user.email,
              });
            }}
          >
            {send}
          </IonButton>
          <IonButton expand="block" color="danger" routerLink="/dashboard">
            Cancel
          </IonButton>
        </IonList>

        <IonAlert
          isOpen={showAlert1}
          onDidDismiss={() => setShowAlert1(false)}
          header={`Note`}
          message={'Allow up to 24 hours to receive funds'}
          buttons={['Okay']}
        />
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.userReducer.user,
    userDBInfo: state.userReducer.userDbInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRequestSweep: (payload: {}) =>
      dispatch(actionCreator.requestSweep(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditItemContainer);
